/* eslint-disable */ import filter from 'lodash/filter.js';
import noop from 'lodash/noop.js';
import without from 'lodash/without.js';
const _events = {};
const BASE_URL = '/';
export default {
    getBaseUrl () {
        return BASE_URL;
    },
    on: function() {
        const registerEventFn = function(event, callback) {
            if (!_events[event]) {
                _events[event] = [];
            }
            _events[event].push(callback);
        };
        registerEventFn.trigger = (event, ...args)=>{
            const events = _events[event] || [];
            return events.map((x)=>Promise.resolve(x(...args)));
        };
        return registerEventFn;
    }(),
    off (event, callback) {
        _events[event] = without(_events[event] || [], callback);
    },
    scriptSupport: {},
    services: {
        infoText: {},
        report: {
            getUrlByShortName (shortname) {
                return `${BASE_URL}Sammanstallning/ShowReport.aspx?ShortName=${encodeURIComponent(shortname)}&ContentOnly=true`;
            }
        },
        logging: {
            logError (...args) {
                console.log('Logging to INCA:', ...args);
            }
        },
        viewTemplate: {
            getById (opt) {
                const { id, error, success, ...options } = opt;
                apiRequest(`/ViewTemplates/${id}/Data`, {
                    method: 'POST',
                    json: options
                }).then((data)=>{
                    (success || noop)(data);
                }, (err)=>{
                    (error || noop)(err);
                });
            }
        }
    },
    user: {
        id: 7909,
        firstName: 'Karl',
        lastName: 'von Testenhaur',
        username: 'testuser',
        email: 'test.user@test.com',
        phoneNumber: null,
        role: {
            id: 43,
            name: 'Inrapportör (Patientöversikt)',
            isReviewer: true
        },
        position: {
            id: 39,
            name: 'Onkologiska kliniken',
            code: '741',
            fullNameWithCode: 'OC Demo (0) - SU/Sahlgrenska (500010) - Onkologiska kliniken (741)'
        },
        region: {
            id: 7,
            name: 'Region Demo'
        },
        previousLogin: '2015-11-05T15:09:32.48Z'
    },
    serverDate: '2015-11-06T08:59:27.338Z',
    form: {
        createDataRow: function(n) {
            let t = this.metadata[n], r, i, u = {
                regvars: {},
                vdlists: {},
                subTables: {}
            };
            for(i in t.regvars){
                t.regvars.hasOwnProperty(i) && (u.regvars[i] = {
                    value: null,
                    include: !0
                });
            }
            for(i in t.vdlists){
                t.vdlists.hasOwnProperty(i) && (u.vdlists[i] = {
                    value: null,
                    include: !0
                });
            }
            for(r = 0; r < t.subTables.length; r += 1){
                u.subTables[t.subTables[r]] = [];
            }
            return u;
        },
        listValuesValidFrom: '0001-01-01T00:00:00Z',
        listValuesValidTo: '9999-12-30T23:00:00Z',
        env: {
            _INREPNAME: '',
            _INUNITNAME: '',
            _REPORTERNAME: '',
            _ADDRESS: 'SJUNETVÄGEN 9 D VÅN 3',
            _AVREGDATUM: '',
            _AVREGORSAK: '',
            _BEFOLKNINGSREGISTER: 'Demo Befolkningsregister',
            _CITY: 'GÖTELABORG',
            _DATEOFDEATH: '',
            _DODSORSAK: '',
            _DODSORSAKSBESKR: '',
            _FIRSTNAME: 'LEIF EGON',
            _FODELSEDATUM: '1214-12-04',
            _FORSAMLING: '17',
            _KOMMUN: '80',
            _LAN: '14',
            _LAND: 'Sweden',
            _LKF: '148017',
            _NAVETDATUM: '2015-04-17',
            _PATIENTID: '117',
            _PERSNR: '12141204-8041',
            _POSTALCODE: '41727',
            _SECRET: 'True',
            _SEX: 'M',
            _SURNAME: 'BIZTALK'
        },
        isReadOnly: false,
        useHtmlLayout: true,
        getValueDomainValues: function(options = {}) {
            const inca = window.inca;
            let registerRecordId = null;
            let errandId = null;
            let documentId = null;
            if (inca.form.data.registerRecordId) {
                registerRecordId = inca.form.data.registerRecordId;
            } else if (inca.form.data.errandId) {
                errandId = inca.form.data.errandId;
            } else if (inca.form.data.documentId) {
                documentId = inca.form.data.documentId;
            }
            fetch(`/api/ValueDomains/ShortName/${encodeURIComponent(options.vdlist)}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    // formControlId: 'frmObj_' + options.vdlist + '_Val',
                    jsonFilter: JSON.stringify(options.filter) || null,
                    parametersFilter: JSON.stringify(options.parameters) || null,
                    designedFormId: inca.form.designedFormId || 10,
                    registerRecordId,
                    documentId,
                    errandId,
                    rowId: options.referringId ? JSON.stringify(options.referringId) : null
                })
            }).then((res)=>{
                return res.json().then((jsonData)=>{
                    if (res.ok) {
                        return jsonData;
                    } else {
                        throw jsonData;
                    }
                });
            }).then((res)=>{
                const filtered = filter(res, (x)=>x.value > 0);
                const result = filtered.map((x)=>{
                    return {
                        id: x.value,
                        text: x.displayText,
                        data: x.data
                    };
                });
                (options.success || noop)(result);
            }).catch((err)=>{
                (options.error || noop)(err.error ? err.error : err);
            });
        },
        reload: ()=>window.location.reload()
    },
    overview: {
        supportsTabs: true,
        tabs: {
            add () {
                console.warn('Tabs are not supported in dev mode.');
            },
            activate () {
                console.warn('Tabs are not supported in dev mode.');
            },
            getCurrentTabId () {
                return 1337;
            },
            getActiveTabId () {
                return 31337;
            },
            setTitle () {}
        },
        openErrand: (errandId)=>alert(`openErrand ${errandId}`),
        openRegisterRecord: (rrId)=>alert(`openRegisterRecord ${rrId}`),
        openDocument: (docId)=>alert(`openDocument ${docId}`),
        refreshOverviewBoxes: ()=>console.log('refreshOverviewBoxes called')
    }
};
